import { TextInput } from 'corso-admin-ui';
import { Controller } from 'react-hook-form';
import { useAutomationFormContext } from '../hooks/useAutomationForm';

export function EventSetOrderShippingTitle() {
  const { control } = useAutomationFormContext();

  return (
    <Controller
      control={control}
      name="event.params.shippingTitle"
      render={({ field, fieldState }) => (
        <TextInput
          id="shipping-title"
          label="Shipping Title"
          details="The name of the shipping title to use for new Shopify orders."
          required
          {...field}
          error={fieldState.error?.message}
        />
      )}
    />
  );
}
